import { techTheme } from 'src/features/common/app/components/theme-provider/theme';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const Container = styled.div<{ hasImage: boolean }>`
    height: 104dvh;
    background-color: ${(props) => (props.hasImage ? 'transparent' : techTheme.colors.cyan500)};

    ${media.sm`
        height: 100vh;
    `}
`;

export const InnerContainer = styled.div`
    position: relative;
    height: 100%;

    ${media.sm`
        height: 100%;
    `}
`;
export const TextContainer = styled.div`
    position: absolute;
    box-sizing: content-box;
    bottom: 0;
    left: 0;
    right: 0;
    color: white;
    border-top: 1px solid rgba(255, 255, 255, 0.4);
    z-index: 1;
    width: 94%;
    margin: 0 16px;

    ${media.sm`
        width: 97%;
        margin: 0 16px;
    `}

    ${media.md`
        width: 98%;
        margin: 0 16px;
    `}

  ${media.lg`
        max-width: 1344px;
        margin: 0 auto;
    `}
`;

export const TextContainerWrapper = styled(FlexBox)`
    gap: 10px;
    flex-direction: column;
    padding: 27px 0;

    ${media.sm`
        flex-direction: row;
        gap: 100px;
    `}

    ${media.md`
        flex-direction: row;
        gap: 280px;
    `}
`;

export const StyledType = styled(Typography)`
    font-size: 11px;

    ${media.sm`
        font-size: 14px;
    `}
`;
export const StyledTitle = styled(Typography)`
    font-size: 16px;

    ${media.sm`
        font-size: 24px;
    `}
`;
export const StyledAuthor = styled(Typography)`
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);

    ${media.sm`
        font-size: 16px;
    `};
`;

export const StyledTypography = styled(Typography)`
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    line-height: 1.4;
`;

export const ImageInnerWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    height: 100%;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }

    ::before {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.62) 100%);
        width: 100%;
        height: 524px;
        content: '';
        z-index: 1;
        position: absolute;
        bottom: 0;
    }
`;